// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2366":"d3048dfbafc291f8","7340":"d3048dfbafc291f8"}[chunkId] + ".css";
};